import React, { FC } from 'react';

import { FormikProps } from 'formik';

//components
import RadioInput from '../../../../../components/inputs/radioInput';
import styled from 'styled-components';

//models
import {
    CartFilterFormValues,
    CMSFilterType,
} from '../../../../../models/cms-placeholder.model';

interface CMSPlaceholderRadioOptionProps {
    formikProps: FormikProps<CartFilterFormValues>;
    isDisabled: boolean;
}
const CMSPlaceholderRadioOption: FC<CMSPlaceholderRadioOptionProps> = ({
    formikProps,
    isDisabled,
}) => {
    return (
        <Container>
            <RadioInput
                name={'cms_filter_type'}
                value={CMSFilterType.GENERAL}
                selectedOption={formikProps.values.cms_filter_type}
                onChange={() =>
                    formikProps.setFieldValue(
                        'cms_filter_type',
                        CMSFilterType.GENERAL,
                    )
                }
                descriptionText={'Use all Items in cart'}
                isDisabled={isDisabled}
            />
            <RadioInput
                name={'cms_filter_type'}
                value={CMSFilterType.SPECIFIC}
                onChange={() =>
                    formikProps.setFieldValue(
                        'cms_filter_type',
                        CMSFilterType.SPECIFIC,
                    )
                }
                selectedOption={formikProps.values.cms_filter_type}
                descriptionText="Only items that match specific filters"
                isDisabled={isDisabled}
            />
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
});
export default CMSPlaceholderRadioOption;
